import React from 'react';
export function FinalCTASection() {
  const handleScrollToForm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    // Try to find the mobile form first, then the desktop form
    const mobileForm = document.getElementById('calculator-form-mobile');
    const desktopForm = document.getElementById('calculator-form');
    // Scroll to whichever form is found first
    if (mobileForm) {
      mobileForm.scrollIntoView({
        behavior: 'smooth'
      });
    } else if (desktopForm) {
      desktopForm.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full bg-[#00be60] py-10 md:py-12" data-id="element-165">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-166">
        <h2 className="text-[22px] md:text-[24px] font-bold text-white mb-4" data-id="element-167">
          Calculate Your Deal Sourcing Costs Now
        </h2>
        <p className="text-[16px] md:text-[18px] text-white mb-8" data-id="element-168">
          See exactly what it costs to build systematic deal flow vs. staying
          dependent on brokers
        </p>
        <button className="bg-white text-[#00be60] px-8 py-4 rounded-md text-[16px] font-bold hover:bg-gray-100 transition-colors scroll-to-form" onClick={handleScrollToForm} data-id="element-169">
          GET MY CALCULATOR →
        </button>
      </div>
    </section>;
}